import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/MessagePopup.module.css';

const MessagePopup = ({ isOpen, message, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className={styles.popupOverlay} onClick={onClose}>
      <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
        <p className={styles.message}>{message}</p>
        <button className={styles.closeButton} onClick={onClose}>
          {t('popups.close')}
        </button>
      </div>
    </div>
  );
};

export default MessagePopup;